export const CATEGORY_RECOMMENDED_OC_PERCENT = {
	داروخانه: { start: 2, end: 5 },
	پوشاک: { start: 7, end: 15 },
	'لوازم آرایشی و بهداشتی': { start: 7, end: 15 },
	'گل و گیاه': { start: 5, end: 15 },
	عطاری: { start: 5, end: 8 },
	'مد و زیورآلات': { start: 3, end: 10 },
	'کتاب و لوازم التحریر': { start: 5, end: 15 },
	'لوازم دیجیتال': { start: 3, end: 10 },
	'لوازم ورزشی و تفریحی': { start: 5, end: 8 },
};

export const DEFAULT_CATEGORY_RECOMMENDED_OC_PERCENT = { start: 5, end: 10 };
